module.exports = __webpack_public_path__ + "static/img/L01.397a6dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/L01.jpg
// module id = Y7cS
// module chunks = 9